import { Chip } from '@mui/material'
import { ASSIGN_TAG } from 'views/Sale/TableService/hooks/useAssignTo'

interface Props {
    tag: string
}

function AssignToChip({ tag }: Props) {
    return (
        <Chip
            sx={{ marginX: 1 }}
            size="small"
            label={tag}
            color={
                tag === ASSIGN_TAG.shared
                    ? 'primary'
                    : tag === ASSIGN_TAG.allBill || tag === ASSIGN_TAG.split
                    ? 'warning'
                    : 'info'
            }
        />
    )
}

export default AssignToChip
